import { useCallback, useState } from 'react'
import useHtmlClass from './useHtmlClass'

const usePopup = (initValue = false)  => {
    const [value, setValue] = useState(initValue)
    const [addHtmlClass, removeHtmlClass] = useHtmlClass()

    const open = useCallback((key = true) => {
        addHtmlClass('has-popup')
        setValue(key)
    }, [])

    const close = useCallback((e) => {
        if('force' === e || (e && e.target && e.target.classList.contains('has-popup-close'))) {
            removeHtmlClass('has-popup')
            setValue(false)
        }
    }, [])

    return [value, open, close]
}

export default usePopup